"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _reactQuery = require("react-query");

var _request = require("@nicbase/request");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var useAdminGatewayProvider = function useAdminGatewayProvider(_ref) {
  var id = _ref.id;
  var queryOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _useRequest = (0, _request.useRequest)(),
      request = _useRequest.request;

  return (0, _reactQuery.useQuery)(['admin', 'gatewayProvider', {
    id: id
  }], /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var _yield$request, provider;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return request({
              type: 'ADMIN_FIND_PROVIDER_BY_ID_REQUEST',
              headers: {
                version: 'v1'
              },
              body: {
                provider: {
                  id: id
                }
              }
            });

          case 2:
            _yield$request = _context.sent;
            provider = _yield$request.body.provider;
            return _context.abrupt("return", provider);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), queryOptions);
};

var _default = useAdminGatewayProvider;
exports["default"] = _default;